// extracted by mini-css-extract-plugin
export default {"dropzoneContainer":"styles_dropzoneContainer__tx34z","dropzoneText":"styles_dropzoneText__wzQ4Z","dropzoneSubText":"styles_dropzoneSubText__HEAn3"};